import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { useTimeClocksContextValue } from '../context/TimeClocksProvider'
import { CompanyPicker } from './CompanyPicker'
import { LocationPicker } from './LocationPicker'

export const TimeClocksFilters = () => {
  const {
    state: { companyId, locationId },
    actions: { setCompanyId, setLocationId },
  } = useTimeClocksContextValue()

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'center']}
      maxWidth={['100%', '100%', '100%', '50%']}
    >
      <Box flex={1} minWidth={0}>
        <CompanyPicker value={companyId} onChange={setCompanyId} />
      </Box>
      <Box flex={1} minWidth={0}>
        <LocationPicker
          value={locationId}
          onChange={setLocationId}
          companyId={companyId}
        />
      </Box>
    </Flex>
  )
}
